import React from 'react';

export const MobileFooter = () => {
  return (
    <div className='flex flex-col absolute w-full pr-12 justify-between text-xs bottom-0'>
      <p className='py-3 text-xs uppercase text-neutral-500'>Socials</p>
      <div className='flex justify-between border-t-[0.2px] text-neutral-300 border-neutral-700 w-full py-3'>
        <p>Instagram</p>
        <p>LinkedIn</p>
        <p>Facebook</p>
      </div>
    </div>
  );
};
